<div fxLayout="column" class="full-height" fxLayoutAlign="center center">
  <h1 class="mat-headline">There's nothing here. 👨🏽‍💻</h1>

  <div fxLayout="row" fxLayoutGap="25px">
    <button mat-raised-button (click)="goBack()" id="page-not-found-btn-back">Go Back</button>
    <button color="primary" mat-raised-button routerLink="/" id="page-not-found-btn-home">Go Home</button>
  </div>
</div>